import React from 'react';
import { Icon, SemanticICONS } from 'semantic-ui-react';
import { CategoryCard, CategoryIcon, CategoryName } from './styles';

interface MobileMenuCategoryProps {
  id: number;
  icon: string;
  text: string;
  isActive: boolean;
  hasSubmenu: boolean;
  onClick: () => void;
}

const MobileMenuCategory: React.FC<MobileMenuCategoryProps> = ({
  icon,
  text,
  isActive,
  onClick
}) => {
  return (
    <CategoryCard isActive={isActive} onClick={onClick}>
      <CategoryIcon isActive={isActive}>
        <Icon name={icon as SemanticICONS} />
      </CategoryIcon>
      <CategoryName isActive={isActive}>{text}</CategoryName>
    </CategoryCard>
  );
};

export default MobileMenuCategory;
